import { Component, Input, OnInit } from '@angular/core';
import { DataService, LoansService, StorageService } from '../../../_services';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-remitacardbankanalytics',
  templateUrl: './remitacardbankanalytics.component.html',
  styleUrls: ['./remitacardbankanalytics.component.css']
})
export class RemitacardbankanalyticsComponent implements OnInit {
  title = 'Remita and account analytics';
  @Input('details') details: any;
  phone_ownership: any;
  average_credit: any;
  average_income: any;
  salary_amount: any;
  token: any;
  @Input('parentRouteId') parentRouteId: any;
  loan: any;
  selected_analytics = '1';
  nodesandscores: any;
  analytics_result: any;
  sub: any;
  currentUser: any;
  data: any;
  view: any = 'data';
  nodes_and_scores: any;
  analytics_last_done = '';
  card:any;
  constructor(
    private loansService: LoansService,
    private storageService: StorageService,
    private route: ActivatedRoute,
    private router: Router,
    private dataService: DataService
  ) {
    this.currentUser = this.storageService.read<any>('currentUser');
  }

  ngOnInit() {
    this.getAnalyticsData();
  }

  getAnalyticsData() {
    this.sub = this.route.params.subscribe(params => {
      this.parentRouteId = +params['id'];
      this.loansService
        .getRemitaCardBankAnalysis(this.currentUser.token, this.parentRouteId)
        .subscribe(data => {
          this.data = data.result;
          this.details = data.result;
          this.nodes_and_scores = data.nodes_and_scores;
          this.analytics_last_done = data.analytics_last_done;
          this.loan = data.loan;
        });
    });
  }
  openModal(section) {
    this.dataService.onOpenApplicationsModal.emit({
      section: section,
      request_id: this.parentRouteId
    });
  }
  dataView() {
    this.view = 'data';
  }

  analyticsView() {
    this.view = 'analytics';
  }
  saveAnalytics(event) {
    this.loansService
      .saveSMSAnalysisData(
        this.currentUser.token,
        this.parentRouteId,
        this.nodes_and_scores,
        this.data
      )
      .subscribe(data => {
        this.data = data.result;
        this.details = data.result;
        this.nodes_and_scores = data.nodes_and_scores;
        this.analytics_last_done = data.analytics_last_done;
        this.loan = data.loan;
      });
  }
  modifyAnalytics(event) {
    this.dataService.onEditApplicationsModal.emit({
      section: 'specific_analytics',
      request_id: this.parentRouteId,
      nodes_and_scores: this.nodes_and_scores,
      selected_analytics: '1',
      analytics_last_done: this.analytics_last_done,
      isedit: '1'
    });
  }
  openOfferLetter(request_id) {
    this.router.navigate(['./applications/offerletter/' + request_id]);
  }
  doingDisbursement(event) {}
}
